export default __webpack_public_path__ + "static/before-5af3f194d9e1fbc380e882ef34e9f8fd.png";